import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let DataInfo = class DataInfo extends Vue {
    get formatSize() {
        return this.size / 1024;
    }
};
tslib_1.__decorate([
    Prop({
        type: String
    })
], DataInfo.prototype, "name", void 0);
tslib_1.__decorate([
    Prop({
        type: Number
    })
], DataInfo.prototype, "size", void 0);
DataInfo = tslib_1.__decorate([
    Component({
        name: 'data-info'
    })
], DataInfo);
export default DataInfo;
